import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

// Same path in both languages (AppRoutesName.EN.PREFERENCES === FR.PREFERENCES).
export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.PREFERENCES,
    loadComponent: () =>
      import('./preferences.component').then((m) => m.PreferencesComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.PREFERENCES + '/:section',
    loadComponent: () =>
      import('./preferences.component').then((m) => m.PreferencesComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PreferencesModule {}
